<div class="flex flex-col flex-auto min-w-0">
    <!-- Header -->
    <div
        class="relative flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-start py-8 px-6 md:px-8 border-b bg-white">
        <!-- Loader -->
        <div class="absolute inset-x-0 bottom-0" *ngIf="loading">
            <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
        </div>
        <!-- Title -->
        <div class="text-4xl font-extrabold tracking-tight">LILATES du jour</div>
    </div>

    <div class="w-full">
        <!-- Recent examinationsSessions table -->
        <div class="xl:col-span-2 flex flex-col flex-auto bg-card shadow overflow-hidden">
            <div class="p-6 flex justify-between">
                <div class="mr-4 text-lg font-medium tracking-tight leading-6 truncate">
                    <button class="bg-accent-400 hover:bg-accent-500 mat-mdc-button-base ng-tns-c445-3 text-white"
                        (click)="clearFilter()" mat-flat-button> Vider les filtres
                    </button>
                </div>
            </div>

            <div class="overflow-x-auto vh-70 border" id="examinationsSessionsTableWrapper">
                <table class="w-full bg-transparent" [formGroup]="filterFormGroup" mat-table matSort
                    [dataSource]="examinationsSessionsDataSource" #examinationsSessionsTable>

                    <!-- Id -->
                    <ng-container matColumnDef="id">
                        <th class="px-2 py-3 border w-4" mat-header-cell *matHeaderCellDef>
                            ID LILATE
                            <input class="header-filters" name="filter-id" formControlName="id" />
                        </th>
                        <td class="px-2" mat-cell *matCellDef="let session">
                            <span class="pr-6 whitespace-nowrap">
                                {{ session.lilate.id }}
                            </span>
                        </td>
                    </ng-container>

                    <!-- Titre -->
                    <ng-container matColumnDef="student">
                        <th class="px-2 py-3 border" mat-header-cell *matHeaderCellDef>
                            <span class="w-full">
                                Candidat
                            </span>
                            <input class="header-filters w-full" name="filter-title" formControlName="student" />
                        </th>
                        <td class="px-2" mat-cell *matCellDef="let session">
                            <span class="pr-6 whitespace-nowrap">
                                {{ session.lilate.student.user.first_name}} {{ session.lilate.student.user.last_name}}
                                ({{session.lilate.student.id}})
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="teacher">
                        <th class="px-2 py-3 border" mat-header-cell *matHeaderCellDef>
                            <span class="w-full">
                                Examinateur
                            </span>
                            <input class="header-filters w-full" name="filter-title" formControlName="teacher" />
                        </th>
                        <td class="px-2" mat-cell *matCellDef="let session">
                            <span class="pr-6 whitespace-nowrap" *ngIf="session.lilate.teacher">
                                {{ session.lilate.teacher.user.first_name }} ({{ session.lilate.teacher.id }})
                            </span>
                            <span class="pr-6 whitespace-nowrap text-secondary" *ngIf="!session.lilate.teacher">—</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="modality">
                        <th class="px-2 py-3 border" mat-header-cell *matHeaderCellDef>
                            <span class="w-full">
                                Modalité
                            </span>
                        </th>
                        <td class="px-2" mat-cell *matCellDef="let session">
                            <span class="px-2 py-1 rounded text-xs font-medium whitespace-nowrap"
                                  [ngClass]="{
                                    'bg-blue-100 text-blue-800': session.lilate.modality === 'ai',
                                    'bg-gray-100 text-gray-800': session.lilate.modality === 'examiner' || !session.lilate.modality
                                  }">
                                {{ session.lilate.modality === 'ai' ? 'IA' : 'Examinateur' }}
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="date">
                        <th class="px-2 py-3 border" mat-header-cell *matHeaderCellDef>
                            <span class="w-full">
                                Date
                            </span>
                        </th>
                        <td class="px-2" mat-cell *matCellDef="let session">
                            <span class="pr-6 whitespace-nowrap">
                                {{ session.lilate.start | date: 'dd/MM/yyyy HH:mm' }}
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="open">
                        <th class="px-2 py-3 border" mat-header-cell *matHeaderCellDef>
                            <span class="w-full">
                                Action
                            </span>
                        </th>
                        <td class="px-2" mat-cell *matCellDef="let session">
                            <div><button (click)="openSession(session)" mat-flat-button
                                    class="mat-button-base mat-flat-button mat-focus-indicator mat-primary ml-3 sm:inline-flex">
                                    Mode ghost
                                </button></div>
                        </td>
                    </ng-container>

                    <tr class="whitespace-nowrap bg-gray-100" mat-header-row
                        *matHeaderRowDef="examinationsSessionsTableColumns;sticky:true">
                    </tr>
                    <tr class="order-row h-16" mat-row *matRowDef="let row; columns: examinationsSessionsTableColumns;">
                    </tr>
                </table>
            </div>
            <mat-paginator class="flex justify-end bg-gray-100" [length]="resultsLength" [pageSize]="page_size"
                aria-label="Select page">
            </mat-paginator>
        </div>
    </div>
</div>